import RentalApi from '../api/rentalApi';
import {actions as notificationActions} from "./notificationActions";
import i18n from "../i18n";

export const actions = {
  tryUnlockBike: (bikeNumber, locations) => async dispatch => {
    try {
      const attemptResponse = await RentalApi.attemptRide(bikeNumber, locations);
      const attemptResult = attemptResponse.data;

      if (!attemptResult) {
        return {success: false};
      }

      if (attemptResult.failure) {
        dispatch(notificationActions.showError(i18n.t(attemptResult.failure.errorCode, {bikeNumber: bikeNumber})));
        return {
          success: false,
          failure: attemptResult.failure,
        };
      }

      const unlockResponse = await RentalApi.requestUnlockBike(
        attemptResult.rideId,
        locations
      );

      const unlockResult = unlockResponse.data;

      if (unlockResult?.failure) {
        dispatch(notificationActions.showError(i18n.t(unlockResult.failure.errorCode, {bikeNumber: bikeNumber})));
        return {
          success: false,
          failure: unlockResult.failure,
        };
      }

      dispatch(notificationActions.showSuccess(i18n.t('unlockBike.successUnlock')));
      return {
        success: true,
        rideId: attemptResult.rideId,
        attemptResult,
        unlockResult,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  },
};
